import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Component } from 'react';
import { TYPEOF } from '../../constants';
import Utils from '../../utils';

var FormValidator = /*#__PURE__*/function (_Component) {
  _inherits(FormValidator, _Component);

  var _super = _createSuper(FormValidator);

  function FormValidator() {
    var _this;

    _classCallCheck(this, FormValidator);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(_args));
    _this.state = {
      data: {},
      valid: {},
      warm: false,
      complete: false
    };

    _this.__refresh = function () {
      var m_data = {};
      var m_valid = {};

      if (typeof _this.props.schema === TYPEOF.OBJECT) {
        for (var _i = 0, _Object$entries = Object.entries(_this.props.schema); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
              key = _Object$entries$_i[0],
              value = _Object$entries$_i[1];

          m_data[key] = '';
          m_valid[key] = _this.validate(key, '');

          if (key == 'cardType' && m_data[key] == '') {
            m_data[key] = 'visa';
            m_valid[key] = _this.validate(key, 'true');
          }
        }
      }

      _this._deep_state_merge_('data', m_data);

      _this._deep_state_merge_('valid', m_valid);
    };

    _this._deep_state_merge_ = function (mergeInto, newData) {
      _this.setState(_defineProperty({}, mergeInto, _objectSpread(_objectSpread({}, _this.state[mergeInto]), newData)));
    };

    _this.dataChangeHandle = function (key, isCheckbox) {
      if (isCheckbox === undefined || isCheckbox === null || isCheckbox === false) {
        return function (event) {
          var newVal = event.target.value;

          _this._deep_state_merge_('valid', _defineProperty({}, key, _this.validate(key, newVal)));

          _this._deep_state_merge_('data', _defineProperty({}, key, newVal));
        };
      }

      return function (event) {
        var newVal = !_this.state.data[key];

        _this._deep_state_merge_('valid', _defineProperty({}, key, _this.validate(key, newVal)));

        _this._deep_state_merge_('data', _defineProperty({}, key, newVal));
      };
    };

    _this.newDataChangeHandle = function (args) {
      var key = args.key,
          value = args.value,
          validated = args.validated;

      _this._deep_state_merge_('valid', _defineProperty({}, key, _this.validate(key, value)));

      _this._deep_state_merge_('data', _defineProperty({}, key, value));
    };

    _this.validate = function (key, value) {
      if (typeof _this.props.schema === TYPEOF.OBJECT) {
        return _this.props.schema[key](value, _this.state.data);
      }

      return false;
    };

    _this.submitHandle = function (event) {
      if (event) {
        event.preventDefault();
      }

      var rval = _this._checkValidation();

      if (rval) {
        if (typeof _this.props.onSubmit === TYPEOF.FUNCTION) {
          _this.props.onSubmit(_this.state.data);
        }
      } else if (typeof _this.props.onValidationFailed === TYPEOF.FUNCTION) {
        _this.props.onValidationFailed();
      }
    };

    _this._checkValidation = function () {
      var rval = true;

      for (var _i2 = 0, _Object$entries2 = Object.entries(_this.state.valid); _i2 < _Object$entries2.length; _i2++) {
        var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
            key = _Object$entries2$_i[0],
            value = _Object$entries2$_i[1];

        if (value == false) {
          rval = false;
        }
      }

      return rval;
    };

    return _this;
  }

  _createClass(FormValidator, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (Utils.quickObjectComparision(prevState.valid, this.state.valid) === false) {
        var rval = this._checkValidation();

        if (rval !== this.state.complete) {
          this.setState({
            complete: rval
          });
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.__refresh();
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.warm === false) {
        this.setState({
          warm: true
        });
        return null;
      }

      return this.props.render({
        data: this.state.data,
        valid: this.state.valid,
        complete: this.state.complete,
        dataChangeHandleFactory: this.dataChangeHandle,
        newDataChangeHandle: this.newDataChangeHandle,
        submitHandle: this.submitHandle
      });
    }
  }]);

  return FormValidator;
}(Component);

export { FormValidator as default };